import { Dispatch } from "redux";
import {
  authenticateActions, getUserActions, logOutActions,
} from "./AuthActions";
import API from "../../API";

export const authenticate = (params: Object) => async (dispatch: Dispatch) => {
  try {
    dispatch(authenticateActions.request());
    const authData = await API.post('/auth/login', params);
    localStorage.setItem("token", authData?.data?.token?.access_token);
    dispatch(authenticateActions.success({ isAuthenticated: true, user: authData?.data }));
  } catch (err) {
    dispatch(authenticateActions.fail(err));
  }
};

export const logOut = () => async (dispatch: Dispatch) => {
  try {
    dispatch(logOutActions.request());
    await API.get('/logout')
    localStorage.removeItem("token");
    dispatch(logOutActions.success({ isAuthenticated: false, user: undefined }));
  } catch (err) {
    dispatch(logOutActions.fail(err));
  }
};

export const getUser = () => async (dispatch: Dispatch) => {
  try {
    if (window.location.pathname === "/login") return;
    dispatch(getUserActions.request());
    const authUser = await API.post("/me");
    dispatch(getUserActions.success({ isAuthenticated: true, user: authUser?.data }));
  } catch (err) {
    console.log(err,' err')
  }
};
